"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var select_1 = tslib_1.__importDefault(require("../../select"));
var MiniSelect = function (props) { return React.createElement(select_1.default, tslib_1.__assign({ size: "small" }, props)); };
MiniSelect.Option = select_1.default.Option;
exports.default = MiniSelect;
//# sourceMappingURL=MiniSelect.js.map